<template>
    <div class="page-table scrollable mainDiv" id="affix-container">
        <div class="page-header card-base card-shadow--small"
             style="height: 0; margin-bottom: 10px; padding: 12px 24px 24px;">
            <el-breadcrumb separator-class="el-icon-arrow-right" style="margin-top: 0">
                <el-breadcrumb-item :to="{ path: '/' }"><i class="mdi mdi-home-outline"></i></el-breadcrumb-item>
                <el-breadcrumb-item> {{$t("src.views.apps.rakamlar.title")}}</el-breadcrumb-item>
                <el-breadcrumb-item> {{$t("src.views.apps.rakamlar.islem.title")}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="card-base baslikBg animated fadeInUp">
            {{$t("src.views.apps.rakamlar.islem.baslikH1")}}
        </div>
        <div class="card-base card-shadow--medium demo-box bg-white animated fadeInUp">
            <el-form status-icon :model="rakamForm" :rules="rulesRakam" ref="rakamForm" class="demo-ruleForm">
                <div>
                    <el-row>
                        <el-col :lg="8" :md="8" :sm="24" :xs="24" class="col-p">
                            <el-form-item :label='$t("src.views.apps.rakamlar.islem.rakamAdi")'
                                          prop="rakamAdi">:
                                <el-input v-model="rakamForm.rakamAdi"
                                          :placeholder='$t("src.views.apps.rakamlar.islem.rakamAdiPlace")'></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :lg="8" :md="8" :sm="24" :xs="24" class="col-p">
                            <el-form-item :label='$t("src.views.apps.rakamlar.islem.rakamAdiEN")'
                                          prop="rakamAdiEN">:
                                <el-input v-model="rakamForm.rakamAdiEN"
                                          :placeholder='$t("src.views.apps.rakamlar.islem.rakamAdiPlace")'></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :lg="8" :md="8" :sm="24" :xs="24" class="col-p">
                            <el-form-item :label='$t("src.views.apps.rakamlar.islem.rakamAdiDE")'
                                          prop="rakamAdiDE">:
                                <el-input v-model="rakamForm.rakamAdiDE"
                                          :placeholder='$t("src.views.apps.rakamlar.islem.rakamAdiPlace")'></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                            <el-form-item :label='$t("src.views.apps.rakamlar.islem.sayi")' prop="sayi">:
                                <el-input v-model="rakamForm.sayi" v-mask="'######'"
                                          :placeholder='$t("src.views.apps.rakamlar.islem.sayiPlace")'></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                            <el-link target="_blank" :underline="false"
                                     href="https://cdn.materialdesignicons.com/4.7.95/">
                                <el-form-item :label='$t("src.views.apps.rakamlar.islem.icon")' prop="icon">:
                                    <el-input v-model="rakamForm.icon"
                                              placeholder="mdi mdi-name"></el-input>
                                </el-form-item>
                            </el-link>
                        </el-col>
                    </el-row>
                </div>
                <el-row class="col-p">
                    <el-form-item>
                        <el-button v-if="btnVisible" size="small" v-on:click="rakamTanimla('rakamForm')"
                                   type="primary">
                            {{$t('src.views.apps.rakamlar.islem.ekle')}}
                        </el-button>
                        <el-button v-else size="small" v-on:click="guncelleme('rakamForm')" type="primary">
                            {{$t('src.views.apps.rakamlar.islem.guncelle')}}
                        </el-button>
                        <el-button v-if="!btnVisible" size="small" v-on:click="vazgec('rakamForm')">
                            {{$t('src.views.apps.rakamlar.islem.vazgec')}}
                        </el-button>
                    </el-form-item>
                </el-row>
            </el-form>
        </div>
        <div class="card-base baslikBg animated fadeInUp delay-1s" style="margin-top: 10px">
            {{$t("src.views.apps.rakamlar.islem.baslikH2")}}
        </div>
        <div class="page-header card-base card-shadow--medium animated fadeInUp delay-1s">
            <el-table
                    :data="rakamlarListe"
                    style="width: 100%">
                <el-table-column
                        prop="rakamAdi"
                        label="Başlık"
                        width="auto">
                </el-table-column>
                <el-table-column
                        prop="sayi"
                        label="Sayı"
                        width="auto">
                </el-table-column>
                <el-table-column
                        label="İşlem"
                        align="right"
                        width="auto">
                    <template slot-scope="scope">
                        <el-tooltip :content='$t("src.views.apps.rakamlar.islem.duzenle")' :open-delay="500"
                                    placement="bottom">
                            <el-button
                                    v-on:click="selectionIndex=scope.$index; selection=scope.row; updateStart(scope.row); "
                                    type="warning"
                                    size="mini"
                                    icon="el-icon-edit">
                            </el-button>
                        </el-tooltip>
                        <el-tooltip :content='$t("src.views.apps.rakamlar.islem.sil")' :open-delay="500"
                                    placement="bottom">
                            <el-button
                                    v-on:click="dialogVisible = true; selection=scope.row; selectionIndex=scope.$index"
                                    size="mini"
                                    type="danger"
                                    icon="mdi mdi-delete">
                            </el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    background
                    layout="sizes,prev, pager, next, jumper, total"
                    :total="total"
                    @size-change="handleSizeChange"
                    @current-change="pageChange"
                    :page-sizes="[10, 20, 50, 100]"
                    :current-page.sync="page"
                    :next-click.sync="page"
                    :prev-click.sync="page"
                    @next-click="pageChange"
                    @prev-click="pageChange">
            </el-pagination>
        </div>
        <el-dialog
                :title='$t("src.views.apps.rakamlar.islem.uyari")'
                :visible.sync="dialogVisible"
                width="30%"
                center>
            <span>"{{selection["rakamAdi"]}}" {{$t('src.views.apps.rakamlar.islem.alertP')}}</span>
            <span slot="footer" class="dialog-footer">
                    <el-button icon="el-icon-check"
                               type="success"
                               size="mini"
                               @click="sil(selection,selectionIndex,rakamlarListe), dialogVisible = false"></el-button>
                    <el-button size="mini" type="danger" icon="el-icon-close"
                               @click="dialogVisible = false"></el-button>
                </span>
        </el-dialog>
    </div>
</template>

<script>

    import rakamService from '../../../WSProvider/RakamService'
    import status from '../../../status'
    import JQuery from 'jquery';

    let $ = JQuery;
    let base64 = require('base64_js');
    let userDataArtdoor = "";
    export default {
        name: "RakamlarIslem",
        mounted() {
            let state = false;
            if (localStorage.getItem("userDataArtdoor")) {
                userDataArtdoor = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataArtdoor"))));
                if (userDataArtdoor["tur"]) {
                    if (userDataArtdoor["tur"] === '1' || userDataArtdoor["tur"] === '2')
                        state = true;
                }
            }
            if (!state) {
                this.$store.commit('setLogout');
                this.$router.push("/login");
            } else {
                if (localStorage.getItem("rakamlarListe")) {
                    this.rakamlarListe = JSON.parse(localStorage.getItem("rakamlarListe"));
                } else {
                    this.getRakamlarList();
                }
            }
        },
        data() {
            return {
                formBase64: '',
                rakamlarListe: [],
                updateKodu: '',
                btnVisible: true,
                selection: '',
                selectionIndex: '',
                dialogVisible: false,

                sizes: 10,
                page: 0,
                postPage: 0,
                total: null,

                rakamForm: {
                    rakamAdi: '',
                    rakamAdiEN: '',
                    rakamAdiDE: '',
                    sayi: '',
                    icon: '',
                },
                rulesRakam: {
                    rakamAdi: [{
                        required: true,
                        message: "Lütfen Rakam Adı Giriniz",
                        trigger: 'blur'
                    }],
                    sayi: [{
                        required: true,
                        message: "Lütfen Sayı Giriniz",
                        trigger: 'blur'
                    }],
                },
            }
        },
        methods: {
            pageChange(val) {
                this.postPage = (val - 1) * this.sizes;
                this.getRakamlarList();
            },
            handleSizeChange(val) {
                this.sizes = val;
                this.getRakamlarList();
            },
            getRakamlarList() {
                let self = this;
                rakamService.rakamListesi(this.postPage, this.sizes).then((response) => {
                    if (response.status === 200) {
                        response.data.forEach(function (e) {
                            if (e.durum === '1') {
                                self.rakamlarListe.push(e);
                            }
                        })
                    } else {
                        status.Status(response.status, this)
                    }
                });
            },
            updateStart(scope) {
                console.log(scope);
                this.rakamForm.rakamAdi = scope.rakamAdi;
                this.rakamForm.sayi = scope.sayi;
                this.rakamForm.icon = scope.icon;
                this.rakamForm.rakamAdiEN = scope.rakamAdiEN;
                this.rakamForm.rakamAdiDE = scope.rakamAdiDE;
                this.updateKodu = scope.rakamKodu;
                this.btnVisible = false;
                var item = {
                    rakamAdi : scope.rakamAdi,
                    sayi : scope.sayi,
                    icon : scope.icon,
                    rakamAdiEN : scope.rakamAdiEN,
                    rakamAdiDE : scope.rakamAdiDE,
                    rakamKodu :scope.rakamKodu
                }
                this.formBase64 = base64.encode(JSON.stringify(item));
            },
            vazgec(formName) {
                this.$refs[formName].resetFields();
                this.btnVisible = true;
            },
            guncelleme(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        var item = {
                            rakamAdi : this.rakamForm.rakamAdi,
                            sayi : this.rakamForm.sayi,
                            icon : this.rakamForm.icon,
                            rakamAdiEN : this.rakamForm.rakamAdiEN,
                            rakamAdiDE : this.rakamForm.rakamAdiDE,
                            rakamKodu :this.rakamForm.rakamKodu
                        }
                        let dil = [{
                            en: this.rakamForm.rakamAdiEN,
                            de: this.rakamForm.rakamAdiDE
                        }];
                        console.log(base64.encode(JSON.stringify(item)))
                        console.log(this.formBase64)
                        if (base64.encode(JSON.stringify(item)) !== this.formBase64) {
                            rakamService.rakamGuncelle(this.updateKodu, this.rakamForm.rakamAdi, this.rakamForm.sayi, this.rakamForm.icon, dil).then((response) => {
                                if (response.status === 200) {
                                    status.Status('success', this, 'Program başarıyla güncellendi...');
                                    this.rakamlarListe.splice(this.selectionIndex, 1);
                                    this.rakamlarListe.splice(this.selectionIndex, 0, {
                                        rakamAdi: response.data.rakamAdi,
                                        rakamAdiEN: response.data.rakamAdiEN,
                                        rakamAdiDE: response.data.rakamAdiDE,
                                        sayi: response.data.sayi,
                                        icon: response.data.icon,
                                        rakamKodu: response.data.rakamKodu
                                    });
                                    this.$refs[formName].resetFields();
                                    this.btnVisible = true;
                                } else if (response.status === 200) {
                                    status.Status('warning', this, 'Bu bilgiler ile kayıtlı bir rakam zaten mevcut');
                                } else {
                                    status.Status(response.status, this)
                                }
                            });

                        } else {
                            status.Status("warning", this, "Herhangi bir değişiklik yapılmadı!");
                        }
                    }
                })
            },
            sil(selection, index, list) {
                rakamService.rakamArsiv(selection.rakamKodu).then((response) => {
                    if (response.status === 200) {
                        status.Status('success', this, 'Rakam başarıyla silindi.');
                        list.splice(index, 1);
                    } else {
                        status.Status(response.status, this)
                    }
                })
            },
            rakamTanimla(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        let dil = [{
                            en: this.rakamForm.rakamAdiEN,
                            de: this.rakamForm.rakamAdiDE
                        }];
                        rakamService.rakamlarTanimlama(this.rakamForm.rakamAdi, this.rakamForm.sayi,this.rakamForm.icon, dil).then((response) => {
                            if (response.status === 200) {
                                status.Status('success', this, 'Rakam başarıyla eklendi.');
                                this.rakamlarListe.push(response.data);
                                this.$refs[formName].resetFields();
                            } else if (response.status === 230) {
                                status.Status('warning', this, 'Bu bilgiler ile kayıtlı bir rakam zaten mevcut');
                            } else {
                                status.Status(response.status, this)
                            }
                        });
                    }
                })
            },
        }
    }

</script>
<style lang="scss" scoped>
    .el-pagination {
        margin-top: 20px;
        float: right;
    }

    .kaldirilmis {
        background: #ec205f;
        color: white;
        font-weight: bold;
        font-size: 16px;
        padding: 10px
    }
</style>

<style scoped>

</style>